<template>
  <div>
    <b-input-group>
      <b-form-input
        id="input_location"
        size="sm"
        :state="state"
        :disabled="isDisabled"
        v-model="query"
        placeholder="Выберите объект"
        autocomplete="off"
        @focus="onFocusIn"
        @blur="onFocusOut"
      />

      <b-input-group-append>
        <slot name="append-btn" :on-clear="onClear" :query="query" :disabled="isDisabled">
          <b-button size="sm" :disabled="!query || isDisabled" @click="onClear">
            <font-awesome-icon icon="times-circle"/>
          </b-button>
        </slot>
      </b-input-group-append>

      <b-list-group class="autocomplete-input-location" v-if="isFocus" :class="{ 'dropUp': dropUp }">
        <b-list-group-item v-for="(item, index) in filteredItems" :key="index" @mousedown="onClick(item)" button>
          <div class="text-small">{{ item.name }}</div>
          <div class="text-secondary text-small">Заказчик: {{item.customer_name}} | Город: {{item.town_name}} |</div>
          <div v-if="item.address" class="text-secondary text-small">Адрес: {{item.address}}</div>
        </b-list-group-item>
        <b-list-group-item v-if="filteredItems.length === 0 && query" disabled>
          <small>Ничего не найдено</small>
        </b-list-group-item>
      </b-list-group>
    </b-input-group>
  </div>
</template>

<script>
import locations from "../../network/locations";

export default {
  name: "LocationSelect",
  mixins: [ locations ],
  props: {
    isDisabled: Boolean,
    value: { type: Number, default: null },
    initialText: { type: String, default: '' },
    state: { type: Boolean, default: null },
    dropUp: { type: Boolean, default: false }
  },
  data() {
    return {
      isFocus: false,
      query: "",
      items: [],
    }
  },
  mounted() {
    this.getItems();
  },
  computed: {
    filteredItems() {
      if (!this.query) return this.items;

      const lowerQuery = this.query.toLowerCase();

      if (this.value) {
        const selected = this.items.find(i => i.id === this.value);
        if (selected.name.toLowerCase() === lowerQuery) return this.items;
      }

      return this.items.filter(item => item.name.toLowerCase().includes(lowerQuery));
    }
  },
  methods: {
    async configure(id) {
      if (id > 0) {
        const result = await this.getLocationById(id);

        if (result && result.data) {
          this.query = result.data.name;
        }
      }
    },
    async getItems(query) {
      const data = {
        query: query,
        payment_type_int: -1,
        currentPage: 1,
        perPage: 400
      }
      const result = await this.getLocationsSearch(data);

      this.items = (result && result.data) ? result.data.items : [];
    },
    onFocusIn() {
      this.isFocus = true;
    },
    onFocusOut() {
      this.isFocus = false;
    },
    onClick(item) {
      this.query = item.name;
      this.$emit('onSelect', item.id, item);
    },
    onClear() {
      this.query = "";
      this.$emit('onSelect', 0, null);
    },
  },
  watch: {
    query: {
      handler(newValue) {
        if (newValue === "" && this.value !== 0) {
          this.$emit('onSelect', 0);
        }
      }
    },
    initialText: {
      handler(newValue) {
        if (this.value && !this.query && newValue) {
          this.query = newValue;
        }
      }, immediate: true
    },
  }
}
</script>

<style>
.autocomplete-input-location {
  max-height: 250px;
  margin-top: 31px;
  min-width: 100%;
  overflow-y: auto;
  position: absolute;
  z-index: 1060;
  top: 0;
}

.autocomplete-input-location .list-group-item {
  padding: 0.5rem 1rem;
}

.autocomplete-input-location.dropUp {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Locations/LocationSelect.vue